// The one query that fetches an article for display. `content` is a dynamic zone:
// populate=* per component, no content.image.
export const ARTICLE_POPULATE =
  'populate[featured_image]=true&populate[auteurs][populate]=photo&populate[content][populate]=*';

export const articleUrl = (slug) =>
  `${process.env.REACT_APP_STRAPI_URL}/api/artikels?filters[slug][$eq]=${slug}&${ARTICLE_POPULATE}`;
